import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';

import { AnnualCountForecastEndpoint } from './annualcountforecastendpoint.service';

import { DepartmentDto } from '../models/Department.model';
import { ExternalDocumentDto } from '../models/ExternalDocument.model';
import { FileUploadDto } from '../models/FileUpload.model';
import { BusinessRuleMessage } from '../models/BusinessRuleMessage.model';

import { AnnualCountForecastItemDto } from '../models/annualcountforecastitem.model';
import { AnnualCountForecastYearVldDto } from '../models/AnnualCountForecastYearVld.model';
import { SessionVldDto } from '../models/SessionVld.model';


@Injectable()

export class AnnualCountForecastService {
  constructor(private router: Router, private annualCountForecastEndpoint: AnnualCountForecastEndpoint) {
  }

  getDepartments(userProfileID?: string) {

    return this.annualCountForecastEndpoint.getDepartments<DepartmentDto[]>(userProfileID);
  }

  getAnnualCountForecastYears(userProfileID?: string) {

    return this.annualCountForecastEndpoint.getAnnualCountForecastYears<AnnualCountForecastYearVldDto[]>(userProfileID);
  }

  getSessions(userProfileID?: string) {

    return this.annualCountForecastEndpoint.getSessions<SessionVldDto[]>(userProfileID);
  }

  getAnnualCountForecastItem(annualCountForecastItemID?: string, userProfileID?: string) {
    return this.annualCountForecastEndpoint.getAnnualCountForecastItem<AnnualCountForecastItemDto>(annualCountForecastItemID, userProfileID);
  }

  getAllAnnualCountForecastItems(userProfileID?: string) {

    return this.annualCountForecastEndpoint.getAllAnnualCountForecastItems<AnnualCountForecastItemDto[]>(userProfileID);
  }

  getAllAnnualCountForecastItemsByYear(userProfileID?: string, annualCountForecastYearVldID?: number) {

    return this.annualCountForecastEndpoint.getAllAnnualCountForecastItemsByYear<AnnualCountForecastItemDto[]>(userProfileID, annualCountForecastYearVldID);
  }

  submitAnnualCountForecastItem(annualCountForecastItem: AnnualCountForecastItemDto) {
    return this.annualCountForecastEndpoint.submitAnnualCountForecastItem<BusinessRuleMessage[]>(annualCountForecastItem);
  }

  async uploadExternalDocument(externalDocuments: ExternalDocumentDto[]) {
    let response = [];
    const formData = new FormData();
    for (let externalDocument of externalDocuments) {
      if (externalDocument.file != null) {
        formData.append(externalDocument.file.name, externalDocument.file);
      }
    }
    if (formData != null && externalDocuments.length > 0) {
      formData.append('folderkey', externalDocuments[0].annualCountForecastItemID);
      await this.annualCountForecastEndpoint.uploadExternalDocument(formData);
    }

    return response;
  }

  downloadFile(externalDocumentID: string, fileName: string) {
    return this.annualCountForecastEndpoint.downloadFile(externalDocumentID, fileName);
  }
}
